<template>
  <div>
    <h2 class="white--text font-weight-bold mb-6">Módulos y Features disponibles</h2>

    <v-progress-circular v-if="loading" indeterminate color="blue" class="d-block mx-auto mt-8"></v-progress-circular>

    <div v-else>
      <div v-for="modulo in modulos" :key="modulo.id" class="mb-4">
        <v-card dark class="rounded-lg" style="background: #1a1a1a">
          <v-card-title class="py-3">
            <v-icon left color="blue lighten-2">mdi-puzzle-outline</v-icon>
            <span class="white--text">{{ modulo.nombre }}</span>
            <v-chip x-small class="ml-3" outlined color="grey">{{ modulo.codigo }}</v-chip>
          </v-card-title>

          <v-card-text v-if="featuresDeModulo(modulo.codigo).length" class="pt-0">
            <div class="caption grey--text mb-2">FEATURES</div>
            <v-chip
              v-for="feature in featuresDeModulo(modulo.codigo)"
              :key="feature.id"
              small
              class="mr-1 mb-1"
              color="teal darken-3"
              dark
            >
              {{ feature.nombre }}
              <span class="ml-1 grey--text text--lighten-1" style="font-size: 0.65rem">({{ feature.codigo }})</span>
            </v-chip>
          </v-card-text>
          <v-card-text v-else class="pt-0 caption grey--text">
            Sin features asociadas
          </v-card-text>
        </v-card>
      </div>

      <div v-if="!modulos.length" class="text-center grey--text py-8">
        No hay módulos disponibles.
      </div>
    </div>

    <div class="mt-4 caption grey--text">
      Módulos y features son definidos en el backend. Se asignan a los planes para controlar el acceso.
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ModulosLista',
  computed: {
    ...mapState('suscripciones', ['modulos', 'features', 'loading']),
  },
  methods: {
    ...mapActions('suscripciones', ['fetchModulos', 'fetchFeatures']),
    featuresDeModulo(codigoModulo) {
      return this.features.filter(f => f.modulo === codigoModulo)
    },
  },
  created() {
    this.fetchModulos()
    this.fetchFeatures()
  },
}
</script>
